The type of the component.

This is always `IdReplayRequest`.
